export default [
  { name: 'Aberdeenshire', code: 'ABE' },
  { name: 'Angus', code: 'ANG' },
  { name: 'Antrim', code: 'ANT' },
  { name: 'Argyll', code: 'ARG' },
  { name: 'Armagh', code: 'ARM' },
  { name: 'Ayrshire', code: 'AYR' },
  { name: 'Banffshire', code: 'BAN' },
  { name: 'Bedfordshire', code: 'BED' },
  { name: 'Berkshire', code: 'BER' },
  { name: 'Berwickshire', code: 'BRW' },
  { name: 'Bristol', code: 'BRI' },
  { name: 'Buckinghamshire', code: 'BUC' },
  { name: 'Buteshire', code: 'BUT' },
  { name: 'Caithness', code: 'CAI' },
  { name: 'Cambridgeshire', code: 'CAM' },
  { name: 'Cheshire', code: 'CHE' },
  { name: 'Clackmannanshire', code: 'CLA' },
  { name: 'Clwyd', code: 'CLW' },
  { name: 'Cornwall', code: 'COR' },
  { name: 'Cumbria', code: 'CUM' },
  { name: 'Derbyshire', code: 'DER' },
  { name: 'Devon', code: 'DEV' },
  { name: 'Down', code: 'DOW' },
  { name: 'Dorset', code: 'DOR' },
  { name: 'Dumfriesshire', code: 'DUM' },
  { name: 'Dunbartonshire', code: 'DUN' },
  { name: 'Durham', code: 'DUR' },
  { name: 'Dyfed', code: 'DYF' },
  { name: 'East Lothian', code: 'ELO' },
  { name: 'East Riding of Yorkshire', code: 'ERY' },
  { name: 'East Sussex', code: 'ESU' },
  { name: 'Essex', code: 'ESS' },
  { name: 'Fermanagh', code: 'FER' },
  { name: 'Fife', code: 'FIF' },
  { name: 'Gloucestershire', code: 'GLO' },
  { name: 'Greater London', code: 'GRE' },
  { name: 'Greater Manchester', code: 'GMA' },
  { name: 'Gwent', code: 'GWE' },
  { name: 'Gwynedd', code: 'GWY' },
  { name: 'Hampshire', code: 'HAM' },
  { name: 'Herefordshire', code: 'HER' },
  { name: 'Hertfordshire', code: 'HRT' },
  { name: 'Inverness-shire', code: 'INV' },
  { name: 'Kent', code: 'KEN' },
  { name: 'Kincardineshire', code: 'KIN' },
  { name: 'Kinross-shire', code: 'KNR' },
  { name: 'Kirkcudbrightshire', code: 'KCB' },
  { name: 'Lanarkshire', code: 'LAN' },
  { name: 'Lancashire', code: 'LCS' },
  { name: 'Leicestershire', code: 'LEI' },
  { name: 'Lincolnshire', code: 'LIN' },
  { name: 'Londonderry', code: 'LON' },
  { name: 'Merseyside', code: 'MER' },
  { name: 'Mid Glamorgan', code: 'MGL' },
  { name: 'Midlothian', code: 'MDL' },
  { name: 'Morayshire', code: 'MOR' },
  { name: 'Norfolk', code: 'NOR' },
  { name: 'North Yorkshire', code: 'NYO' },
  { name: 'Northamptonshire', code: 'NTH' },
  { name: 'Northumberland', code: 'NBL' },
  { name: 'Nottinghamshire', code: 'NOT' },
  { name: 'Orkney', code: 'ORK' },
  { name: 'Oxfordshire', code: 'OXF' },
  { name: 'Peeblesshire', code: 'PEE' },
  { name: 'Perthshire', code: 'PER' },
  { name: 'Powys', code: 'POW' },
  { name: 'Renfrewshire', code: 'REN' },
  { name: 'Ross-shire', code: 'ROS' },
  { name: 'Roxburghshire', code: 'ROX' },
  { name: 'Rutland', code: 'RUT' },
  { name: 'Selkirkshire', code: 'SEL' },
  { name: 'Shetland', code: 'SHE' },
  { name: 'Shropshire', code: 'SHR' },
  { name: 'Somerset', code: 'SOM' },
  { name: 'South Glamorgan', code: 'SGL' },
  { name: 'South Yorkshire', code: 'SYO' },
  { name: 'Staffordshire', code: 'STA' },
  { name: 'Stirlingshire', code: 'STI' },
  { name: 'Suffolk', code: 'SUF' },
  { name: 'Surrey', code: 'SUR' },
  { name: 'Sutherland', code: 'SUT' },
  { name: 'Tyne and Wear', code: 'TYN' },
  { name: 'Tyrone', code: 'TYR' },
  { name: 'Warwickshire', code: 'WAR' },
  { name: 'West Glamorgan', code: 'WGL' },
  { name: 'West Lothian', code: 'WLO' },
  { name: 'West Midlands', code: 'WMI' },
  { name: 'West Sussex', code: 'WSU' },
  { name: 'West Yorkshire', code: 'WYO' },
  { name: 'Wigtownshire', code: 'WIG' },
  { name: 'Wiltshire', code: 'WIL' },
  { name: 'Worcestershire', code: 'WOR' }
];
